import { ROUTES } from '@/shared/constants/routes';
import { useTrans } from '@/shared/hooks/useTranslation';
import { WorkspaceSourceBar } from '@/view/features/dataConsole';
import { Loader } from '@/view/shared/Loader';
import { useWorkspaceSourceScopeViewModel } from '@/viewmodel/features/dataConsole';
import { SourceProjectContext } from '@/viewmodel/features/etlSource';
import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

export function WorkspaceSourceRoute({ children }: Readonly<{ children: ReactNode }>): ReactNode {
  const { t } = useTrans();
  const page = useWorkspaceSourceScopeViewModel();

  if (page.isNotFound) return <Navigate to={ROUTES.DATA_CONSOLE} replace />;
  if (page.isError) {
    return <p className="text-sm text-status-danger-fg">{t('dataConsole.loadError')}</p>;
  }
  if (!page.scope) return <Loader />;

  return (
    <SourceProjectContext.Provider value={page.scope}>
      <WorkspaceSourceBar
        projectName={page.projectName}
        isStore={page.isStore}
        isHidden={page.isFullScreenStep}
        onBack={page.backToSources}
        onOpenAccess={page.openAccess}
      />
      <div className="flex-1 min-h-0">{children}</div>
    </SourceProjectContext.Provider>
  );
}
